import { render } from "./RolesAdministracion.vue?vue&type=template&id=267b28d4"
import script from "./RolesAdministracion.vue?vue&type=script&lang=js"
export * from "./RolesAdministracion.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__